import { HomeOutlined } from "@ant-design/icons";
import { routes } from "core/router/config/routes";
import { useBreadcrumbs } from "core/router/navigation/useBreadcrumbs";
import { setDefaultActiveKey } from "core/setup/redux/state/tabs/tabState";
import { useAppDispatch } from "core/utils";
import i18n from "i18next";
import type { FC } from "react";

import { BreadcrumbLinkStyle, BreadcrumbStyle, BreadcrumbTextStyle } from "./BreadcrumbStyles";

export const Breadcrumbs: FC = () => {
    const dispatch = useAppDispatch();
    const items = useBreadcrumbs();

    if (!items) {
        return null;
    }

    return (
        <BreadcrumbStyle
            className="aevi-breadcrumb"
            items={[
                {
                    title: (
                        <BreadcrumbLinkStyle to={routes.dashboard.fillPathParams()} aria-label={i18n.t("menu.dashboard")}>
                            <HomeOutlined />
                        </BreadcrumbLinkStyle>
                    ),
                },
                ...items.map((item) => ({
                    title: item.to ? (
                        <BreadcrumbLinkStyle
                            to={item.to}
                            onClick={item.tabKey ? () => dispatch(setDefaultActiveKey(item.tabKey)) : undefined}
                        >
                            {i18n.t(item.labelKey)}
                        </BreadcrumbLinkStyle>
                    ) : (
                        <BreadcrumbTextStyle>{i18n.t(item.labelKey)}</BreadcrumbTextStyle>
                    ),
                })),
            ]}
        />
    );
};
